import { useEffect } from "react";
import { useUiStore, applyTheme } from "@/store/uiStore";

// Applies the persisted theme to <html> on first paint.
export function ThemeInit() {
  const theme = useUiStore((s) => s.theme);
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);
  return null;
}

export default ThemeInit;
